import { UseSeller } from '@/contexts/seller/types'
import { useRef } from 'react'
import { useActiveOrdersForSidebar } from '@/proxy/order/hooks'
import { SCHEDULED_ORDERS_COUNT_SIDEBAR_POLLING_TIME } from '@/seller.application.polling.time.config.js'
import { SIDEBAR_MENU as dict } from '@/resources/dict'
import { ActiveOrder, SidebarMenuItem } from '@/resources/types'
import { SidebarMenuItems } from '@/resources/enums'

interface Props {
  useSeller: UseSeller
  menuItems: SidebarMenuItem[]
  setMenuItems: (items: SidebarMenuItem[]) => void
}

const useSidebarScheduledHandler = ({
  useSeller: { hasTwinSeller },
  menuItems,
  setMenuItems,
}: Props) => {
  const scheduledOrdersCount = useRef<number | undefined>(undefined)

  const handleScheduledMenuItem = (menuItem: SidebarMenuItem) => {
    if (menuItem.id === SidebarMenuItems.SCHEDULED) {
      const count = scheduledOrdersCount.current
      menuItem.text = `${dict.scheduledOrders}${count !== undefined ? ` (${count})` : ''}`
      if (hasTwinSeller) menuItem.featureFlag = false
    }
  }

  const updateScheduledOrdersCount = (scheduledOrders: ActiveOrder[]) => {
    const count = scheduledOrders.length
    if (count === scheduledOrdersCount.current) return
    scheduledOrdersCount.current = count

    const scheduledMenuItem = menuItems
      .find(item => item.id === SidebarMenuItems.ORDERS)
      ?.submenu?.find(item => item.id === SidebarMenuItems.SCHEDULED)

    if (scheduledMenuItem) {
      handleScheduledMenuItem(scheduledMenuItem)
      setMenuItems([...menuItems])
    }
  }

  useActiveOrdersForSidebar(
    {
      refetchInterval: SCHEDULED_ORDERS_COUNT_SIDEBAR_POLLING_TIME,
      refetchIntervalInBackground: true,
    },
    updateScheduledOrdersCount
  )

  return {
    handleScheduledMenuItem,
  }
}

export default useSidebarScheduledHandler
